<template>
  <div class="app">
    <Base v-if="show" />
    <Modal v-if="modal.show" class="fadeIn animated">
      <Content v-if="modal.type === 'content'"></Content>
      <Rule v-if="modal.type === 'rule'"></Rule>
    </Modal>
    <Loading v-if="loading" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Vue from 'vue';
import Base from '~/views/base/base.vue';
import Loading from '~/components/loading.vue';
import Modal from '~/components/Modal/modal.vue';
import Orientation from '~/components/Orientation/orientation.vue';
import store from '~/store/index';
import * as types from '~/store/mutation-type';
import alert from '~/components/Alert';
import confirm from '~/components/Confirm';
import Content from '~/components/Content/index.vue';
import Rule from '~/components/Rule/index.vue';
import 'animate.css/animate.min.css';
import '@babel/polyfill';

Vue.prototype.$alert = alert;
Vue.prototype.$confirm = confirm;

export default {
  components: {
    Loading,
    Modal,
    Base,
    Content,
    Rule,
    Orientation
  },
  data() {
    return {
      show: false
    }
  },
  computed: {
    ...mapState({
      modal: state => state.modal,
      loading: state => state.loading,
      alert: state => state.alert
    })
  },
  mounted() {
    console.log('loading app');
    store.commit(types.SHOW_LOADING, true);
    // 解决ios输入之后键盘收起后留白
    document.body.addEventListener('focusout', function() {
      window.scrollTo(0, document.documentElement.clientHeight);
    });
    this.show = true;
  },
  methods: {
    closeAlert() {
      store.commit(types.HIDE_ALERT);
    },
    close() {
      store.commit(types.HIDE_MODAL);
    }
  }
}
</script>

<style rel="stylesheet/stylus" lang="stylus">
    .app
        width 100%
        background #000
    ::-webkit-scrollbar
        width: 6px;
        height: 6px;
        /* background-color:#fff; */
        // display: none;

    ::-webkit-scrollbar:hover
        background-color: #eee;

    ::-webkit-scrollbar-thumb
        min-height: 5px;
        min-width: 5px;
        -webkit-border-radius: 20px;
        border: 1px solid #AAA;
        background-color: #AAA;

    ::-webkit-scrollbar-thumb:hover
        min-height: 5px;
        min-width: 5px;
        -webkit-border-radius: 20px;
        border: 1px solid #444;
        background-color: #444;

    ::-webkit-scrollbar-thumb:active
        -webkit-border-radius: 20px;
        border: 1px solid #444;
        background-color: #444;
</style>
